import React from 'react';
import './style.css';

const HighlightSubstring = ({ text, substring }) => {
  if (!substring) return <span>{text}</span>;

  const regex = new RegExp(substring, 'gi');
  let lastIndex = 0;
  const elements = [];

  text.replace(regex, (match, index) => {
    elements.push(text.slice(lastIndex, index));
    elements.push(<span key={index} className="highlight">{text.slice(index, index + match.length)}</span>);
    lastIndex = index + match.length;
  });

  elements.push(text.slice(lastIndex));

  return <span>{elements}</span>;
};

export default HighlightSubstring;
